import { useEffect, useState } from 'react';
import { NavLink, Outlet, useMatch, useParams } from 'react-router-dom';
import { api } from '../lib/api';

export type ProjectDetail = {
  project: {
    id: number;
    name: string;
    description: string | null;
    theme_color: string;
    archived: number;
  };
  members: Array<{ id: number; name: string; email: string; role: string }>;
  settings: Array<{ module_key: string; enabled: number }>;
  categories: Array<{ id: number; name: string; sort_order: number }>;
  workflow: Array<{ id: number; name: string; sort_order: number }>;
  context_text: string;
};

const TABS = [
  { to: 'documents', label: 'Documents', module: 'documents' },
  { to: 'taches', label: 'Tâches', module: 'taches' },
  { to: 'communication', label: 'Communication', module: 'communication' },
  { to: 'perso', label: 'Espace perso', module: 'espace_perso' },
  { to: 'ifc', label: 'IFC', module: 'ifc' },
  { to: 'captures', label: 'Captures 3D', module: 'ifc' },
  { to: 'synthese', label: 'Synthèse', module: null },
  { to: 'parametres', label: 'Paramètres', module: null },
];

export default function ProjectHome() {
  const { id } = useParams<{ id: string }>();
  const [detail, setDetail] = useState<ProjectDetail | null>(null);
  // Quand on est sur /projets/:id/documents/:docId → vue document plein espace
  const inDocView = !!useMatch('/projets/:id/documents/:docId');

  useEffect(() => {
    if (!id) return;
    api.get<ProjectDetail>(`/projects/${id}`).then(setDetail).catch(() => setDetail(null));
  }, [id]);

  if (!detail) return <div className="card card-meta">Chargement du projet…</div>;

  const enabled = new Map(detail.settings.map((s) => [s.module_key, !!s.enabled]));

  if (inDocView) {
    // Vue document : header projet masqué, le viewer occupe tout
    return <Outlet context={detail} />;
  }

  return (
    <>
      <div className="topbar">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span
            style={{
              width: 14,
              height: 14,
              borderRadius: 4,
              background: detail.project.theme_color,
            }}
          />
          <h1>{detail.project.name}</h1>
        </div>
      </div>

      <div className="project-tabs">
        {TABS.filter((t) => t.module === null || enabled.get(t.module)).map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            className={({ isActive }) => `project-tab ${isActive ? 'active' : ''}`}
          >
            {t.label}
          </NavLink>
        ))}
      </div>

      <Outlet context={detail} />
    </>
  );
}
